import { default as BoiteBip, default as BoiteBouton } from 'assets/img/boite-bouton.png';
import CableDebrayage from 'assets/img/boite-cable-debrayage.png';
import BoiteCleCableDebrayage from 'assets/img/boite-cle-cable-debrayage.png';
import BoiteCle from 'assets/img/boite-cle.png';
import MoteurCentrale from 'assets/img/rideau-moteur-centrale.png';
import MoteurLaterale from 'assets/img/rideau-moteur-laterale.png';
import MoteurTubulaire from 'assets/img/rideau-moteur-tubulaire.png';
import { searchProduct } from 'odooApi/product';
import formInputsTypes from '../../simulatorConstant';

import ACM120 from 'assets/img/ACM-120.png';
import ACM140 from 'assets/img/ACM-140.png';
import ACM190 from 'assets/img/ACM-190.png';
import Gaposa120 from 'assets/img/Gaposa-120.png';
import Gaposa140 from 'assets/img/Gaposa-140.png';
import Gaposa190 from 'assets/img/Gaposa-190.png';
import { AxeMotoriseRM, BoiteRM, marqueMoteur } from '../data';

export const CATEG_ID_MOTEUR_RIDEAU = 36;
export const BoiteRMData = {
	id: 'BoiteRMData',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Boite',
	name: 'BoiteRMData',
	className: 'col-12',
	nextStepData: false,
	nextStep: false,
	options: BoiteRM,
	
};

const puissance = {
	id: 'RM-PUISSANCE',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Puissance moteur',
	name: 'puissance',
	className: 'col-12',
	nextStepData: BoiteRMData,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const typeMotorisation =
			currentFormValue?.values?.typeMotorisation?.value;
		const marque =
			currentFormValue?.values?.marque?.value || '';

		let puissances = [];

		switch (typeMotorisation) {
			case 'latéral':
				puissances = [220, 380, 400, 500, 750];
				break;

			case 'tubulaire':
				puissances = [250, 300, 400, 550, 650];
				break;

			case 'central triphasé':
				puissances = [250, 400, 550, 650, 1000];
				break;

			case 'central monophasé':
				puissances = [120, 140, 180, 190, 220];
				break;

			default:
				puissances = [];
		}

		const options = puissances.map((p) => ({
			id: String(p),
			label: `${p} Nm`,
			value: String(p),
			nextStep: false,
			description: `- Puissance moteur ${p} Nm ${marque} \n` + 
			`- Moteur filaire avec fins de courses mécaniques s'effectuant grâce à un système progressif équipé d'une bague mémoire integrée dans le boitier de protection.\n ` +
			"- Axe d'ancrage de (60 mm) équipé d'une couronne de diamètre 220 mm"
		}));

		fnSuccess(options);
	},
};


const marque = {
	id: 'RM-LAT-MARQUE',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Marque',
	name: 'marque',
	className: 'col-12',
	nextStepData: puissance,
	nextStep: false,
	options: marqueMoteur
};


const RideauMetalliqueMotorisationData = {
	id: 'AxeMotoriseRMData',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Motorisation',
	name: 'typeMotorisation',
	className: 'col-6',
	nextStepData: marque,
	nextStep: false,
	options: AxeMotoriseRM
};

export default RideauMetalliqueMotorisationData;
